import { useCallback } from 'react';

interface IProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  visitedStep: number;
}

export const useStepNavigation = ({ setCurrentStep, visitedStep }: IProps) => {
  const handleNextStep = useCallback(() => {
    setCurrentStep((prev) => prev + 1);
  }, [setCurrentStep]);

  const handleBackStep = useCallback(() => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  }, [setCurrentStep]);

  const handleStepClickButton = useCallback(
    (stepNum: number) => {
      setCurrentStep((prev) => {
        if (stepNum <= prev || stepNum === prev + 1 || stepNum <= visitedStep) {
          return stepNum;
        }
        return prev;
      });
    },
    [setCurrentStep, visitedStep],
  );

  return {
    handleNextStep,
    handleBackStep,
    handleStepClickButton,
  };
};
